import { UserAssociation } from '@core/models';

export function isUserAssociationDisabled(association?: UserAssociation): boolean {
  return association?.disabled === true || association?.user?.active === false;
}
